import { render } from "./PopupThongTinNhomThe.vue?vue&type=template&id=2d9b9472"
import script from "./PopupThongTinNhomThe.vue?vue&type=script&lang=js"
export * from "./PopupThongTinNhomThe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__